export interface BeforeAfterItem {
  id: string;
  title: string;
  location: string;
  type: string;
  product: string;
  before: string;
  after: string;
  desc: string;
}

// ✅ 이미지 교체 방법:
// before / after 에 실제 이미지 URL을 붙여넣으세요.
// 또는 설치사례 페이지에서 카드 위 "이미지 변경" 버튼을 눌러 직접 수정할 수 있습니다.

export const beforeAfterCases: BeforeAfterItem[] = [
  {
    id: "ba1",
    title: "강남구 아파트 현관",
    location: "서울 강남구",
    type: "아파트",
    product: "마스터즈 도어락 8600",
    before: "https://public.readdy.ai/ai/img_res/b627aad5986276c243fc98f97d4585d0.jpg",
    after: "https://readdy.ai/api/search-image?query=brand%20new%20premium%20smart%20digital%20door%20lock%20installed%20on%20clean%20apartment%20entrance%20door%2C%20sleek%20black%20touchscreen%20keypad%2C%20modern%20Korean%20apartment%20hallway%2C%20bright%20clean%20interior%2C%20professional%20installation%20complete%2C%20after%20renovation&width=700&height=500&seq=ba_after1&orientation=landscape",
    desc: "노후 열쇠 도어락 → 지문인식 스마트 도어락으로 교체. 보안성과 편의성이 동시에 업그레이드됐습니다."
  },
  {
    id: "ba2",
    title: "마포구 오피스텔",
    location: "서울 마포구",
    type: "오피스텔",
    product: "유니코 T250",
    before: "https://readdy.ai/api/search-image?query=old%20basic%20numeric%20keypad%20door%20lock%20on%20officetel%20entrance%2C%20outdated%20digital%20lock%2C%20worn%20buttons%2C%20old%20residential%20door%2C%20before%20security%20upgrade%2C%20dim%20hallway&width=700&height=500&seq=ba_before2&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=modern%20slim%20touchscreen%20smart%20door%20lock%20installed%20on%20officetel%20door%2C%20sleek%20minimalist%20design%2C%20clean%20white%20door%2C%20bright%20modern%20hallway%2C%20after%20security%20upgrade%2C%20professional%20installation&width=700&height=500&seq=ba_after2&orientation=landscape",
    desc: "구형 번호키 → 슬림 터치스크린 도어락으로 교체. 인테리어와 완벽하게 어우러지는 세련된 디자인."
  },
  {
    id: "ba3",
    title: "분당 단독주택 현관",
    location: "경기 성남시",
    type: "단독주택",
    product: "마스터즈 도어락 7100",
    before: "https://readdy.ai/api/search-image?query=old%20mechanical%20door%20lock%20on%20wooden%20house%20entrance%20door%2C%20traditional%20key%20lock%2C%20aged%20wooden%20door%2C%20before%20home%20security%20upgrade%2C%20suburban%20house%20entrance%2C%20worn%20hardware&width=700&height=500&seq=ba_before3&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=premium%20smart%20door%20lock%20installed%20on%20luxury%20single%20family%20house%20wooden%20entrance%20door%2C%20high%20tech%20fingerprint%20lock%2C%20beautiful%20home%20exterior%2C%20after%20security%20upgrade%2C%20warm%20lighting%2C%20upscale%20residential%20entrance&width=700&height=500&seq=ba_after3&orientation=landscape",
    desc: "기존 열쇠 잠금장치 → 지문+카드+번호 복합 인증 도어락으로 업그레이드. 가족 모두 편리하게 사용 중."
  },
];
